module.exports = __webpack_public_path__ + "img/mod_logo.44bb2184.png";